<template>
  <div class="help-center-new" :class="{hasSearch: keyword}">
    <div class="ipt-box">
      <span class="icon"></span>
      <Field
        v-model="keyword"
        class="ipt"
        :placeholder="$t('helpCenterNew.m00001')"
        clearable
        @input="search" />
    </div>
    <div class="search-list" v-if="keyword.length > 0">
      <template v-if="searchList.length > 0">
        <p class="item"
           v-for="item in searchList"
           v-html="item.title"
           :key="item.id"
           @click="toDetail(item.id)"
        >
        </p>
      </template>
      <template v-else>
        <Empty :description="loading ? $t('helpCenterNew.m00002') : $t('helpCenterNew.m00003')"></Empty>
      </template>
    </div>
    <div class="list-box" v-if="hotQAList.length > 0">
      <p class="list-title">{{ $t('helpCenterNew.m00004') }}</p>
      <div class="list-1">
        <p class="item" v-for="item in hotQAList" @click="toDetail(item.id)">
          {{item.title}}
        </p>
      </div>
    </div>
    <div class="list-box type-list">
      <p class="list-title">{{ $t('helpCenterNew.m00005') }}</p>
      <div
        class="item"
        v-for="item in categoryTreeList"
        :key="item.id"
        @click="toLevel2(item.id)">
        <span class="icon"></span>
        <p class="title">{{ item.title }}</p>
        <span class="arrow"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Empty } from "vant";

export default {
  components: {
    Field, Empty
  },
  data() {
    return {
      hotQAList: [],
      keyword: '',
      loading: false,
      searchList: [],
      categoryTreeList: []
    }
  },
  created() {
    this.getHelpTopLists();
    this.getHelpCategoryTree();
  },
  methods: {
    getHelpTopLists(){
      this.$apis.getHelpTopLists({
        is_top: 1,
        page_size: 6,
        page: 1
      }).then(res => {
        this.hotQAList = res.data;
      })
    },
    getHelpCategoryTree(){
      this.$apis.getHelpCategoryTree({
        display: 'document'
      }).then(res => {
        this.categoryTreeList = res.tree;
      })
    },
    search(){
      if(!this.keyword){
        this.searchList = [];
        this.loading = false;
        return;
      }
      this.loading = true
      this.$apis.getHelpTopLists({
        is_top: 0,
        page_size: 10,
        page: 1,
        keyword: this.keyword
      }).then(res => {
        this.searchList = res.data.map(item => {
          
          item.title = item.title.replaceAll(this.keyword, `<span style="color:#F24E1E">${this.keyword}</span>`);
          return item;
        });
      }).finally(() => {
        this.loading = false
      })
    },
    toDetail(id){
      this.$router.push({
        path: `/help-center/details`,
        query: {
          ...this.$route.query,
          id
        }
      })
    },
    toLevel2(id){
      this.$router.push({
        path: `/help-center/level2`,
        query: {
          ...this.$route.query,
          id
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.help-center-new{
  overflow: hidden;
  &.hasSearch{
    max-height: 100vh;
  }
  .ipt-box{
    margin: 15px 32px 22px;
    position: relative;
    display: flex;
    .icon{
      position: absolute;
      z-index: 9;
      left: 32px;
      top: 18px;
      width: 48px;
      height: 48px;
      background: url("../../assets/images/help-center-new/search.png") no-repeat;
      background-size: 100% 100%;
    }
    .ipt{
      flex: 1;
      border: none;
      padding-left: 96px;
      line-height: 84px;
      background: #f9f9f9;
      border-radius: 42px;
    }
  }
  .search-list{
    min-height: 100vh;
    padding: 22px 32px 0;
    .item{
      padding: 22px 0;
      line-height: 56px;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        left: -50%;
        bottom: 0;
        width: 200%;
        height: 1px;
        background: #EBEBEB;
        transform: scale(0.5);
      }
    }
  }
  .list-box{
    padding: 0 32px;
    .list-title{
      line-height: 88px;
      font-size: 34px;
      font-weight: 600;
    }
    .list-1{
      .item{
        line-height: 64px;
        font-size: 28px;
        position: relative;
        padding-left: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &::before{
          content: '';
          position: absolute;
          left: 0;
          top: 25px;
          background: #000;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
    }
  }
  .type-list{
    margin-top: 25px;
    .item{
      display: flex;
      align-items: center;
      padding: 22px 0;
      position: relative;
      &:nth-of-type(1) {
        padding-top: 10px;
      }
      &:after{
        content: '';
        position: absolute;
        left: -50%;
        bottom: 0;
        width: 200%;
        height: 1px;
        background: #EBEBEB;
        transform: scale(0.5);
      }
      .icon{
        width: 96px;
        height: 96px;
        background: url("../../assets/images/help-center-new/icon-level-1.png") no-repeat;
        background-size: 100% 100%;
      }
      .title{
        flex: 1;
        font-size: 32px;
        font-weight: 500;
      }
      .arrow{
        width: 32px;
        height: 32px;
        background: url("../../assets/images/help-center-new/arrow.png") no-repeat;
        background-size: 100% 100%;
      }
      
    }
  }
}

</style>